<template>

<q-drawer v-if="isAdmin && app_state().openDrawerRight"
    v-model="app_state().openDrawerRight"
    side="right"
    bordered
    :breakpoint="700"
    :behavior="$_hasTouch ? 'mobile' : 'desktop'"
		:class="'hide-scroll-bar'+($_isDesktop ? ' bg-transparent' : '')">
    <!-- elevated -->

	<q-scroll-area class="fit"
                :thumb-style="app_state().scrollarea_bar_style_left">

	<!-- <transition enter-active-class="animated fadeInRight" leave-active-class="animated fadeOutLeft" duration="500"> -->
        <!-- <transition name="slide-fade" duration="600" mode="in-out">
            <div v-if="app_state().openDrawerRight"> -->

                <q-list>

                    <!-- <q-item class="bg-primary q-px-sm q-mx-none"> -->
                    <q-item class="q-px-sm q-mx-none">

                        <q-item-section avatar v-if="$_hasTouch" class="q-px-none q-mx-none" style="min-width: 26px">
                            <q-btn icon="close" @click="()=> { app_state().openDrawerRight = false; if(!$_isMobile){ app_state().openDrawerLeft = true} }" color="white" flat round dense />
                        </q-item-section>
                        <q-item-section class="q-px-none q-mx-none">
                            <q-item-label header class="text-whit text-bold ellipsis q-px-sm q-mx-none"
							            style="max-width: 210px">
                                CONTRÔLES
                            </q-item-label>
                        </q-item-section>
                    </q-item>

                <!-- PARAMETRES de l'Appli -->
                    <q-item v-if="isAdmin" @click="link(route('parameters.index'))" clickable>
                        <q-item-section>
                            <q-item-label>Paramètres</q-item-label>
                            <q-item-label caption>divers réglages de l'application</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-icon name="settings" size="28px" color="secondary" />
                        </q-item-section>
                    </q-item>


            <!-- UNIT TEST -->
    <!--				<q-item v-if="app_state().d.userAdminSuper || app_state().d.userAdminBasic">
                        <q-item-section>
                            <q-item-label caption>Tests Unitaire</q-item-label>
                        <q-item-label caption>sur des pages du Site Web</q-item-label>
                        </q-item-section>
                        <q-item-section>
                            <q-btn :loading="loadingBtnTest" @click.native="testUnit()" label="Tester" color="secondary" />
                            <span slot="loading">Test en cours...</span>
                        </q-item-section>
                    </q-item>-->

            <!-- EMPTY CACHE / COOKIES / LOCAL STORAGE - only for 'webmaster' role -->
                    <q-item v-if="isMaster && showBtnEmptyCache">
                        <q-item-section>
                            <q-item-label>Vider le cache</q-item-label>
                            <q-item-label caption>dossiers et fichiers de vues, cookies et local</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-btn :loading="loadingBtnCache" @click="emptyCache()" icon="delete_outline" color="secondary" dense />
                        </q-item-section>
                    </q-item>


            <!-- SAVE BDD -->
                    <q-item v-if="isAdmin">
                        <q-item-section>
                            <q-item-label>Télécharger la BDD</q-item-label>
                            <!-- <q-item-label caption></q-item-label> -->
                            <q-item-label caption>en fichier compressé .zip</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-btn @click="appStore().dumpDB()" icon="archive" color="secondary" dense />
                        </q-item-section>
                    </q-item>

            <!-- EXPORT APPLI -->
                    <q-item v-if="isMaster">
                        <q-item-section>
                            <q-item-label>Exporter toute l'Appli !</q-item-label>
                            <q-item-label caption>code source</q-item-label>
                            <q-item-label caption>en fichier compressé tar.gz</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-btn :loading="loadingBtnExportAppli" @click="exportAppli()" icon="cloud_download" color="secondary" dense />
                        </q-item-section>
                    </q-item>

                    <q-dialog v-if="isMaster" v-model="loadingBtnExportAppli" persistent no-backdrop-dismiss no-esc-dismiss no-route-dismiss>
                        <q-card v-if="stateExportAppli == 'creating'" class="q-pa-md">
                            <h6 class="text-center text-grey q-my-sm">Veuillez patientez pendant la création de l'archive...</h6>
                            <p class="text-grey text-center">
                                Compression en cours...
                                <br/><br/><q-spinner-oval :size="48" color="primary" />
                                <br/><br/><small>Un téléchargement vous sera proposé à la fin du processus.</small>
                            </p>
                        </q-card>
                        <q-card v-if="stateExportAppli == 'downloading'" class="q-pa-md">
                            <p class="text-center q-my-md">
                                <q-btn label="Télécharger l'archive" @click="open(exportAppliArchivePath + exportAppliArchiveName)"
                                        :download="exportAppliArchiveName" color="green" icon-right="cloud_download" />
                            </p>
                            <p class="text-grey text-center q-mt-lg">
                                À la fin du téléchargement, le bouton ci-dessous vous permettra de supprimer cette archive du serveur (obligatoire) et fermera cette fenêtre.
                                <br/><q-btn label="Supprimer l'archive du serveur" @click="deleteArchiveExportAppli()" icon="delete_outline" color="green" outline class="q-mt-md" />
                            </p>
                        </q-card>
                    </q-dialog>


            <!-- EXPORT DATAS APPLI (images et autres fichiers dans /public/storage/ et public/uploads/images/) -->
                    <q-item v-if="isAdmin"       :disable=" ! isMaster">
                        <q-item-section>
                            <q-item-label>Exporter les données de l'Appli !</q-item-label>
                            <q-item-label caption>images, fichiers, ...</q-item-label>
                            <q-item-label caption>en fichier compressé tar.gz</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-btn          :disable=" ! isMaster"     :loading="loadingBtnExportDatasAppli" @click="exportDatasAppli()" icon="cloud_download" color="secondary" dense />
                        </q-item-section>
                    </q-item>
                    <q-dialog v-if="isAdmin" v-model="loadingBtnExportDatasAppli" persistent no-backdrop-dismiss no-esc-dismiss no-route-dismiss>
                        <q-card v-if="stateExportDatasAppli == 'creating'" class="q-pa-md">
                            <h6 class="text-center text-grey q-my-sm">Veuillez patientez pendant la création de l'archive...</h6>
                            <p class="text-grey text-center">
                                Ceci va prendre quelques secondes...
                                <br/><br/><q-spinner-oval :size="48" color="primary" />
                                <br/><br/><small>Un téléchargement vous sera proposé à la fin du processus.</small>
                            </p>
                        </q-card>
                        <q-card v-if="stateExportDatasAppli == 'downloading'" class="q-pa-md">
                            <p class="text-center q-my-md">
                                <q-btn label="Télécharger l'archive" @click="open(exportDatasAppliArchivePath + exportDatasAppliArchiveName)"
                                        :download="exportDatasAppliArchiveName" color="green" icon-right="cloud_download" />
                            </p>
                            <p class="text-grey text-center q-mt-lg">
                                À la fin du téléchargement, le bouton ci-dessous vous permettra de supprimer cette archive du serveur (obligatoire) et fermera cette fenêtre.
                                <br/><q-btn label="Supprimer l'archive du serveur" @click="deleteArchiveExportDatasAppli()" icon="delete_outline" color="green" outline class="q-mt-md" />
                            </p>
                        </q-card>
                    </q-dialog>


            <!-- SYSTEM USAGE -->
                    <q-item class="q-pt-lg" @click="listenSystemUsage = !listenSystemUsage" clickable>
                        <q-item-section>
                            <q-item-label>Surveillance du Système</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-toggle v-model="listenSystemUsage" icon="power_settings_new"  color="primary"/>
                        </q-item-section>
                    </q-item>
                    <q-item v-if="listenSystemUsage">
                        <q-item-section avatar><q-icon name="memory" /></q-item-section>
                        <q-item-section v-if="cpu">
                            <q-item-label>{{ 'CPU ('+ nbrCpu +'cœurs)' }}</q-item-label>
                        </q-item-section>
                        <q-item-section side v-if="cpu">
                            <q-circular-progress v-if="!cpuError.length" :value="cpu" :thickness="0.2" color="purple-6" size="24px" track-color="grey-3" center-color="grey-8" class="q-mt-sm"/>
                            <span v-if="!cpuError.length">{{ cpu+'%' }}</span>
                            <p v-else v-text="cpuError" class="text-red"></p>
                        </q-item-section>
                    </q-item>
                    <q-item v-if="listenSystemUsage">
                        <q-item-section avatar><q-icon name="developer_board" /></q-item-section>
                        <q-item-section>
                            <q-item-label>{{ 'Mémoire utilisée / '+ memoryTotal + 'Go' }}</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-circular-progress :value="memoryUsed" :thickness="0.2" color="teal-6" size="24px" :indeterminate="!memoryUsed" track-color="grey-3" center-color="grey-8" class="q-mt-sm"/>
                            <span>{{ memoryUsed+'%' }}</span>
                        </q-item-section>
                    </q-item>


            <!-- SIZE APPLI -->
                    <q-item v-if="loadingSizeAppli" class="q-pt-lg">
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                    </q-item>
                    <q-item v-else class="q-pt-lg">
                        <q-item-section avatar>
                            <q-icon :name="(sizeAppliPercent < 90) ? 'disc_full' : 'adjust'" :color="(sizeAppliPercent > 90) ? 'negative' : 'positive'"/>
                        </q-item-section>
                        <q-item-section>
                            <q-item-label lines="2">Espace disque occupé: {{ sizeAppliPercent }}%</q-item-label>
                            <q-item-label caption>max. {{ utils.config?.max_space_disk_in_go }}Go</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-circular-progress :value="sizeAppliPercent" :thickness="0.2" :color="sizeAppliColorProgress"
                                :indeterminate="!sizeAppliTotal" class="q-mt-sm" size="30px"/>
                        </q-item-section>
                    </q-item>

                    <q-item>
                        <q-popup-proxy class="q-pa-sm">Espace disque occupé par les différents fichiers, tous dossiers confondus (sans les dossiers systèmes)</q-popup-proxy>
                        <q-item-section>Taille Totale de l'Appli :
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizeAppliTotal + sizeAppliTotalExtension +' / '+ sizeAppliMax }}Go</span>
                        </q-item-section>
                    </q-item>

                    <q-item>
                        <q-item-section avatar><q-icon name="save" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>Sauvegardes BDD</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <!-- <span v-else>{{ sizeDumpDB + sizeDumpDBExtension }}</span> -->
                            <span v-else>{{ sizeDumpDB }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Tailles des différentes sauvegardes de la base de données</q-banner></q-popup-proxy>
                    </q-item>

                    <q-item>
                        <q-item-section avatar><q-icon name="image" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>Photos Colis</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizeColisFiles }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Dossier comprenant les photos des colis</q-banner></q-popup-proxy>
                    </q-item>


                    <q-item>
                        <q-item-section avatar><q-icon name="description" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>Lettres de Voiture</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizeCarrierDocFiles }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Dossier comprenant les fichiers de lettres de voiture</q-banner></q-popup-proxy>
                    </q-item>


                    <q-item>
                        <q-item-section avatar><q-icon name="description" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>Preuves de Livraisons</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizePodFiles }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Dossier comprenant les fichiers des preuves de livraisons</q-banner></q-popup-proxy>
                    </q-item>



                    <q-item>
                        <q-item-section avatar><q-icon name="image" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>Photos Profils</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizeProfileFiles }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Dossier comprenant les photos des profils utilisateurs</q-banner></q-popup-proxy>
                    </q-item>

                    <!-- <q-item>
                        <q-item-section avatar><q-icon name="image" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>Miniatures</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizeThumbs }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Dossier comprenant les miniatures des fichiers téléversés</q-banner></q-popup-proxy>
                    </q-item> -->

                    <!-- <q-item>
                        <q-item-section avatar><q-icon name="" color="grey-7" /> </q-item-section>
                        <q-item-section>
                            <q-item-label>XXXX</q-item-label>
                        </q-item-section>
                        <q-item-section side>
                            <q-spinner-oval v-if="loadingSizeAppli" size="22" color="primary"></q-spinner-oval>
                            <span v-else>{{ sizeXXXX + sizeXXXXExtension }}</span>
                        </q-item-section>
                        <q-popup-proxy><q-banner>Dossier comprenant les images des utilisateurs, enfants, ...</q-banner></q-popup-proxy>
                    </q-item> -->

                    <q-separator />



            <!-- INFOS Système -->
                    <q-item-label header>Versions Système :</q-item-label>
                    <!-- <q-item v-if="utils.infos.php_version && utils.infos.laravel_version"> -->
                    <q-item dense>
                        <q-item-section><q-item-label caption>PHP</q-item-label></q-item-section>
                        <q-item-section side><b>{{ utils.infos.php_version }}</b></q-item-section>
                    </q-item>
                    <q-item dense>
                        <q-item-section><q-item-label caption>Laravel</q-item-label></q-item-section>
                        <q-item-section side><b>{{ utils.infos.laravel_version }}</b></q-item-section>
                    </q-item>
                    <q-item dense>
                        <q-item-section><q-item-label caption>Vue</q-item-label></q-item-section>
                        <q-item-section side><b>{{ vueVersion }}</b></q-item-section>
                    </q-item>
                    <q-item dense>
                        <q-item-section><q-item-label caption>Quasar</q-item-label></q-item-section>
                        <q-item-section side><b>{{ $q.version }}</b></q-item-section>
                    </q-item>

                </q-list>


            <!-- </div>
        </transition> -->
    </q-scroll-area>
</q-drawer>


<!-- Modal result UNIT TEST -->
<!--	<q-dialog v-model="showModalTestUnit" :content-css="{padding: '10px', maxWidth: '90vw', maxHeight: '90vh'}">
		<h4>Test Unitaire</h4>
		<div v-dompurify-html="resultTestUnit"></div>
		<q-btn color="primary" @click="showModalTestUnit = false" label="Fermer" />
	</q-dialog>-->

</template>

<script>
// import {/*  mapState, */ mapActions } from 'vuex'
import { /* pp, proto, */ app_state, notify, e, link, open } from '@helpers'

import  {appStore}  from '@stores'

import { ref } from '@vue/reactivity'
import { onMounted, watch } from '@vue/runtime-core'
// import { useStore } from 'vuex'

export default {
	name: 'DrawerRight',

    setup(){

		// SYSTEM USAGE
        let gsu                             = ref(null)
        let timeToRepeatRequestSystemUsage  = ref(8000)
        let listenSystemUsage               = ref(false)
        let countRequestSystemUsage         = ref(0)
        let maxRequestSystemUsage           = ref(20) // max request

        let cpu         = ref(0)
        let nbrCpu      = navigator.hardwareConcurrency
        let cpuError    = ref('')

        let memoryTotal = ref(0)
        let memoryUsed  = ref(0)

		// SIZE APPLI
		let sizeAppliTotal = ref(0)
		let sizeAppliTotalExtension = ref('')

        let sizeDumpDB = ref('')
        // let sizeDumpDBExtension = ref('')

		let sizeColisFiles = ref('')
		let sizeCarrierDocFiles = ref('')
		let sizePodFiles = ref('')
		let sizeProfileFiles = ref('')

		// let sizeThumbs = ref('')
		// // let sizeThumbsExtension = ref('')

		let sizeAppliPercent = ref(0)
		let sizeAppliMax = ref(0)
		let sizeAppliColorProgress = ref('positive')
		let loadingSizeAppli = ref(true) // spinner

		// CACHE
		let showBtnEmptyCache = ref(true)
		let loadingBtnCache = ref(false)

		// EXPORT APPLI
		let loadingBtnExportAppli = ref(false)
		let exportAppliArchivePath = ref('')
		let exportAppliArchiveName = ref('')
		let stateExportAppli = ref('creating')

		// EXPORT DATAS APPLI
		let loadingBtnExportDatasAppli = ref(false)
		let exportDatasAppliArchivePath = ref('')
		let exportDatasAppliArchiveName = ref('')
		let stateExportDatasAppli = ref('creating')


        // Launch Get System Usage
        function launcherGSU(){
			if( ! gsu.value && listenSystemUsage.value ){
				getSystemUsage();
				gsu.value = setInterval(getSystemUsage, timeToRepeatRequestSystemUsage.value);
			}
			// gsu.value;
		}
        // Stop Request System Usage
		function resetSystemUsage(){
			clearInterval(gsu.value);
			gsu.value = null;
			countRequestSystemUsage.value = 0;
		}
		// Request System Usage
		function getSystemUsage(){

			if(countRequestSystemUsage.value == maxRequestSystemUsage.value){
				resetSystemUsage();
				return;
			}
			countRequestSystemUsage.value++;

			axios.get(route('system-usage'))
				.then(response => {
					var res = response.data.data;

					// CPU
					if(typeof Number(res.cpu) !== 'number'){
						cpu.value = 0;
						cpuError.value = res.cpu.error;
					} else {
						cpu.value = Number(res.cpu); // %
					}

					// MEMORY
					memoryTotal.value = res.memory.total; // Go
					memoryUsed.value = Number(res.memory.used); // %
				})
				.catch((error) => {
					e("components/DrawerRight.vue - getSystemUsage", error);
				});
		}

        // SIZE APPLI
		function getSizeAppli(){

			// await axios.get('/system/size-appli')
			axios.get(route('system-size-appli'))
				.then(response => {
					var res = response.data;
		            // log('in getSizeAppli() - res : ', res);

					sizeAppliTotal.value = Number(res.sizeAppli.size);
					sizeAppliTotalExtension.value = res.sizeAppli.extension;

					sizeDumpDB.value = res.sizeDumpDB.size// + res.sizeDumpDB.extension

                    sizeColisFiles.value = res.sizeColisFiles.size

                    sizeCarrierDocFiles.value = res.sizeCarrierDocFiles.size

                    sizePodFiles.value = res.sizePodFiles.size

                    sizeProfileFiles.value = res.sizeProfileFiles.size

                    // sizeThumbs.value = res.sizeThumbs.size// + res.sizeThumbs.extension


					sizeAppliPercent.value = Number(res.percent);
					sizeAppliColorProgress.value = sizeAppliPercent.value < 80 ? 'positive' : (sizeAppliPercent.value > 90 ? 'negative' : 'amber-10');


					sizeAppliMax.value = (((res.sizeMax / 1024) / 1024) / 1024).toFixed(0); // Go

					_.defer(()=>{
						loadingSizeAppli.value = false;
					});
				})
				.catch((error) => {
					loadingSizeAppli.value = false;
					e("Components/DrawerRight.vue - getSizeAppli", error);
				});
		}


		function resetExportAppli(){
			stateExportAppli.value == 'creating'
			loadingBtnExportAppli.value = false;
			exportAppliArchivePath.value = ''
            exportAppliArchiveName.value = '';
			app_state().right = false; // ferme le volet de droite
		}
        function resetExportDatasAppli(){
			stateExportDatasAppli.value == 'creating'
			loadingBtnExportDatasAppli.value = false;
			exportDatasAppliArchivePath.value = ''
            exportDatasAppliArchiveName.value = '';
			app_state().right = false; // ferme le volet de droite
		}

        onMounted(()=>{
            // if(pp().isAdmin){
                launcherGSU()
            // }
        })



        // let app = ref(app_state)

        watch(app_state, v =>{ // when opened/closed DrawerRight

            if( ! v.openDrawerRight){
			    listenSystemUsage.value = false; // stop listen system usage when close the drawer

                // v.openDrawerLeft = Boolean(! proto.$_hasTouch)// ? true : false;
                // v.openDrawerLeft = proto.$_hasTouch ? false : true;

			} else {
                v.openDrawerLeft = false;
// log('in DrawerRight',v)
				launcherGSU();// system usage

				if( ! sizeAppliTotal.value){
					getSizeAppli();// size appli
				}
			}
        }, { deep: true })

        watch(listenSystemUsage, v =>{ // when change toggle button system usage

            if( ! v){
				resetSystemUsage();
			} else {
				launcherGSU();
			}
        })


        // const store = useStore()

        return {
            app_state, link, open,
            appStore,

            // dumpDB: () => store.dispatch('app/dumpDB'),

		    // SYSTEM USAGE
            gsu, timeToRepeatRequestSystemUsage, listenSystemUsage, countRequestSystemUsage, maxRequestSystemUsage,
            cpu, nbrCpu, cpuError,
            memoryTotal, memoryUsed,

		    // SIZE APPLI
            sizeAppliTotal, sizeAppliTotalExtension,
            sizeDumpDB, //sizeDumpDBExtension,
            sizeColisFiles,
            sizeCarrierDocFiles,
            sizePodFiles,
            sizeProfileFiles,
            // sizeThumbs,// sizeThumbsExtension,
            sizeAppliPercent, sizeAppliMax, sizeAppliColorProgress, loadingSizeAppli,

		    // CACHE
            showBtnEmptyCache, loadingBtnCache,

		    // EXPORT APPLI
            loadingBtnExportAppli, exportAppliArchivePath, exportAppliArchiveName, stateExportAppli,

		    // EXPORT DATAS APPLI
            loadingBtnExportDatasAppli, exportDatasAppliArchivePath, exportDatasAppliArchiveName, stateExportDatasAppli,


            exportAppli:()=>{

                $q.dialog({ title: 'Exporter l\'appli', ok:{label:'Commencer'},cancel:true,
                    message: "Êtes-vous sûr ? Ceci peut prendre quelques minutes...",
                }).onOk(()=>{

                    loadingBtnExportAppli.value = true;

                    axios.get(route('export-appli'))//, {}, { responseType:'blob' } )
                        .then((res) => {
                            if(res.data.error){
                                notify("negative", res.data.error);
                            } else {
                                exportAppliArchivePath.value    = res.data.archive_path;
                                exportAppliArchiveName.value    = res.data.archive_name;
                                stateExportAppli.value		    = 'downloading';
                            }
                        })
                        .catch((error) => {
                            loadingBtnExportAppli.value = false;
                            e("components/DrawerRight.vue - exportAppli", error);
                        });
                })
            },
            deleteArchiveExportAppli(){

                axios.post(route('delete-archive-export-appli'), { filename: exportAppliArchiveName.value } )
                    .then((res) => {
                        resetExportAppli();

                        if(res.data.error){
                            return notify('negative', res.data.error +" Contactez votre Webmaster préféré...");
                        }
                        notify('positive', "Archive supprimée de l'espace disque du serveur.");
                    })
                    .catch((error) => {
                        resetExportAppli();
                        notify('negative', "Impossible de supprimer l'archive. Contactez votre Webmaster préféré...");
                    });
            },


            exportDatasAppli(){
                loadingBtnExportDatasAppli.value = true;

                axios.get(route('export-datas-appli'))//, {}, { responseType:'blob' } )
                    .then((res) => {
                        if(res.data.error){
                            notify("negative", res.data.error);
                        } else {
                            exportDatasAppliArchivePath.value   = res.data.archive_path;
                            exportDatasAppliArchiveName.value   = res.data.archive_name;
                            stateExportDatasAppli.value		    = 'downloading';
                        }
                    })
                    .catch((error) => {
                        loadingBtnExportDatasAppli.value = false;
                        e("components/DrawerRight.vue - exportDatasAppli", error);
                    });

            },
            deleteArchiveExportDatasAppli(){

                axios.post(route('delete-archive-export-datas-appli'), { filename: exportDatasAppliArchiveName.value } )
                    .then((res) => {
                        resetExportDatasAppli();

                        if(res.data.error){
                            return notify('negative', res.data.error +" Contactez votre Webmaster préféré...");
                        }
                        notify('positive', "Archive supprimée de l'espace disque du serveur.");
                    })
                    .catch((error) => {
                        resetExportDatasAppli();
                        notify('negative', "Impossible de supprimer l'archive. Contactez votre Webmaster préféré...");
                    });
            },


            // VIDER LES DOSSIERS ET LES VUES EN CACHE, LES COOKIES ET LOCAL STORAGE
            emptyCache:()=>{

                notify("info", "Merci de patienter... Vidage du cache en cours...",2000);

                loadingBtnCache.value = true;

                axios.get(route('system-empty-cache'))
                    .then(response => {

                        $q.localStorage.clear(); // clear local storage

                        var arr_cookies = Object.keys($q.cookies.getAll())

                        arr_cookies.forEach((v) => { // clear cookies
                            if( ! (/TOKEN|session/g).test(v) ){
                                $q.cookies.remove(v);
                            }
                        });

                        loadingBtnCache.value = false;
                        showBtnEmptyCache.value = false; // hide button when cache is empty

                        getSizeAppli();// size appli

                        _.delay(()=>{
                            notify("positive", "Dossiers et Vues en cache vidés.");
                        }, 2000)
                    })
                    .catch((error) => {
                        loadingBtnCache.value = false;
                        e("components/DrawerRight.vue - emptyCache", error);
                    });
            },
        }
    },



		// TEST UNITAIRE
//		testUnit(){
//			this.loadingBtnTest = true;
//
//			axios.post('/test-unit')
//				.then(response => {
//					this.resultTestUnit = '<p><b>Version Laravel</b> : '+ response.data.app_version +'</p><p><b>Sur les pages :</b> '+response.data.list+'</p><p><b>Résultats :</b><br/><pre>'+response.data.action+'</pre></p><br/>';
//					this.loadingBtnTest = false;
//					this.showModalTestUnit = true;
//				})
//				.catch((error) => {
//					this.loadingBtnTest = true;
//					fn.error("components/DrawerRight.vue - testUnit", error);
//				});
//		},


	// }

}
</script>
